// @flow

import React, { type Node } from 'react';
import classNames from 'classnames';
import { createStyleSheet } from 'jss-theme-reactor';
import PropTypes from '@catalytic/pushbot-ui/utils/PropTypes';
import { Display1 as Component } from '@catalytic/pushbot-ui/Text';

type Props = {
  children?: Node,
  /**
   * Root className
   */
  className?: string
};

const DISPLAY_NAME = 'Display';

export const styleSheet = createStyleSheet(DISPLAY_NAME, theme => ({
  root: theme.mixins.gutters(2)
}));

export default function Display(props: Props, context: Object) {
  const { children, className: classNameProp, ...other } = props;
  const classes = context.styleManager.render(styleSheet);
  const className = classNames(classes.root, classNameProp);

  return (
    <Component paragraph className={className} {...other}>
      {children}
    </Component>
  );
}
Display.displayName = DISPLAY_NAME;
Display.contextTypes = {
  styleManager: PropTypes.styleManager.isRequired
};



// WEBPACK FOOTER //
// ./js/AppStructure/Display.js